import Template from './overlay.vue';

let globalOptions = {
    show: false,
    closable: false,
    loading: false,
    loading_img: '',
    color: '',
};

let instance;

const Init = function(config = {}) {
    let Tpl = this.extend(Template);
    
    if(!instance) instance = new Tpl();
    config = {
        ...globalOptions,
        ...instance.$data,
        ...config
    };
    for(let key in config) {
        if(config.hasOwnProperty(key)) {
            instance.$data[key] = config[key];
        }
    }
}

const Show = function(config = {}){
    Init.call(this, config);

    instance.$data.show = true;
    document.body.style.overflow = 'hidden';
    document.body.appendChild(instance.$mount().$el);
}

const Loading = function(config = {}){
    config = {
        ...{loading: true, closable: false},
        ...config
    };
    Show.call(this, config);
}


const Hide = function(){
    if (instance && instance.$data.show) {
        instance.$data.show = false;
        try {
            const el = instance.$mount().$el;
            if (el && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        } catch (error) {
            console.warn('Overlay hide error:', error);
        }
        document.body.style.overflow = '';
    }
}

export default {
    install(Vue) {
        Vue.prototype.$overlay = Init.bind(Vue);
        Vue.prototype.$overlay.show = Show.bind(Vue);
        Vue.prototype.$overlay.loading = Loading.bind(Vue);
        Vue.prototype.$overlay.hide = Hide.bind(Vue);
    }
}